import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/fonts/acrom/stylesheet.css';
import reportWebVitals from './reportWebVitals';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {App} from './App';
import {AlertProvider} from './context/alert';
import AlertBanner from "./components/AlertBanner";
import {UserProvider} from './context/user';
import {getFirebaseToken } from './firebase'
import NotificationHandler from "./context/notifications";
import { ClaimUnreadSocketListener } from "./components/ClaimUnreadSocketListener";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const client = new QueryClient();

// Request notification permission
function requestNotificationPermission() {
    Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
            console.log('Notification permission granted.');
            return registerServiceWorker();
        } else {
            console.log('Unable to get permission to notify.');
        }
    }).catch((err) => {
        console.log('Error requesting notification permission.', err);
    });
}

// Register service worker
function registerServiceWorker() {
    if ('serviceWorker' in navigator) {
        // чистим старую регистрацию на кастомном scope иначе остаётся sw который не управляет страницей
        navigator.serviceWorker.getRegistrations().then((regs) =>
            regs.forEach((r) => { if (r.scope.includes("firebase-cloud-messaging-push-scope")) r.unregister(); })
        );
        navigator.serviceWorker.register('/firebase-messaging-sw.js')
            .then((registration) => {
                console.log('Service Worker registered with scope:', registration.scope);
                return new Promise((resolve, reject) => {
                    if (registration.active) {
                        resolve(registration);
                    } else {
                        registration.addEventListener('updatefound', () => {
                            const installingWorker = registration.installing;
                            if (installingWorker == null) {
                                reject(new Error('Service worker installation failed'));
                            } else {
                                installingWorker.addEventListener('statechange', () => {
                                    if (installingWorker.state === 'activated') {
                                        resolve(registration);
                                    } else if (installingWorker.state === 'redundant') {
                                        reject(new Error('Service worker installation failed'));
                                    }
                                });
                            }
                        });
                    }
                });
            })
            .then((registration) => {
                console.log('Service Worker ready');
                return getFirebaseToken();
            })
            .then((token) => {

            })
            .catch((err) => {
                console.log('Service Worker registration failed:', err);
            });
    }
}

requestNotificationPermission();

root.render(
    <React.StrictMode>
        <QueryClientProvider client={client}>
            <UserProvider>
                <AlertProvider>
                    <AlertBanner/>
                    <NotificationHandler/>
                    <ClaimUnreadSocketListener/>
                    <App/>
                </AlertProvider>
            </UserProvider>
        </QueryClientProvider>
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
